'use client';

import { CallIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

type SupportNumberFabProps = {
  supportPhone: string;
};

export default function SupportNumberFab({
  supportPhone,
}: SupportNumberFabProps) {
  return (
    <a
      href={`tel:${supportPhone}`}
      className="flex items-center justify-center bg-primary-500 hover:bg-primary-600 text-white px-4 py-3 rounded-full shadow-lg
      transition-all duration-300 hover:scale-105 hover:shadow-xl"
    >
      <HugeiconsIcon
        icon={CallIcon}
        size={24}
        className="text-white animate-wiggle"
      />
      <span className="ml-2 font-medium">কল করুন</span>
    </a>
  );
}
